import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents } from '@/utils/amplitude/analytics/core.types';
import { AmplitudePageName, getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

export enum LotRecommendationType {
    AvailableOnChairish = 'Available on Chairish',
    ItemsInAuction = 'Items In Auction',
    MoreItems = 'More Items',
    RecentlyViewed = 'Recently Viewed',
    RecommendedCategory = 'Recommended Category',
    RecommendedItems = 'Recommended Items',
    RelatedCategory = 'Related Category',
    SimilarSaleHistory = 'Similar Sale History',
    TrendingItems = 'Trending Items',
    YouMayAlsoLike = 'You May Also Like',
}

export enum LotRecommendationTrigger {
    HouseNameClick = 'House Name Click',
    ImageClick = 'Image Click',
    TitleClick = 'Title Click',
}

export type TrackLotRecommendationClickedPayload = {
    catalogId: number;
    houseId: number;
    itemId: number;
    lotClickPosition: number;
    pageName: AmplitudePageName;
    recommendationName: LotRecommendationType;
    trigger: LotRecommendationTrigger;
    url: string;
};

export const trackLotRecommendationClickedAnalytics = (payload: TrackLotRecommendationClickedPayload) => {
    track(TrackingEvents.Item.LotRecommendationClicked, payload);
};

export const useTrackLotRecommendationClickedAnalytics = () => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(
        (payload: Omit<TrackLotRecommendationClickedPayload, 'pageName' | 'url'>) => {
            trackLotRecommendationClickedAnalytics({
                ...payload,
                pageName: getAmplitudePageNameFromPath(pathname),
                url,
            });
        },
        [pathname, url]
    );
};
